import React from "react";
import { Link } from "react-router-dom";
import "./CallToAction.css";
function CallToAction(props) {
  return (
    <Link to={props.link} style={{ textDecorationLine: "none" }}>
      <div class="cto-button cto-shadow cto-animate cto-blue">
        <span
          style={{ marginRight: "10px", fontSize: "20px", marginTop: "8px" }}
        >
          {props.text}
        </span>

        {props?.icon}
      </div>
    </Link>
  );
}

export default CallToAction;
